import React from 'react'
import doctor from '../img/clinic.jpg'

const About = () => {
  return (
    <>
      <section className="about-section">
        <div className="container">
          <div className="row clearfix">
            {/* Content column */}
            <div className="content-column col-md-6 col-sm-12 col-xs-12">
              <div className="inner-column">
                <div className="sec-title">
                  <div className="title">About Clinic </div>
                  <h4>We Are A Leading Health Clinic Providing Care From Physicians and Dentists</h4>
                </div>
                <p className="text">
                Welcome to our Health Clinic, where we offer expert care from experienced physicians and dentists. Our clinic has been a trusted provider of quality healthcare for the community, delivering comprehensive services in both general health and dental care.
                </p>
               
                <a href="about.html" className="theme-btn btn-style-three">Read More</a>
              </div>
            </div>

            {/* Image column */}
            <div className="image-column col-md-6 col-sm-12 col-xs-12">
              <div className="" data-wow-delay="0ms" data-wow-duration="1500ms">
                <div className="image">
                  <img src={doctor} alt="Experienced Doctor" />
                  {/* <div className="overlay-box">
                    <div className="year-box">
                      <span className="number">5</span>Years <br/> Experience <br/> Working
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default About
